// Zahl am Warenkorb-Symbol sichtbar halten (Shop-Audit K08, 02.10.2026).
// Assortion schreibt nach einem Kauf die neue Zahl direkt in den Kreis am Warenkorb-Symbol.
// Das Theme blendet den Kreis bei leerem Warenkorb mit der Klasse «hidden» aus und hebt sie
// danach nicht wieder auf; erst nach dem Neuladen war die Zahl zu sehen. Darum folgt die
// Sichtbarkeit hier der angezeigten Zahl: grösser als 0 sichtbar, sonst ausgeblendet.
(function () {
  'use strict';

  var IDS = ['cart-icon-bubble', 'mobile-cart-icon-bubble'];

  function countFromText(text) {
    var value = String(text || '').trim();
    if (value === '99+') return 100;
    var count = parseInt(value, 10);
    return isNaN(count) ? 0 : count;
  }

  function sync(bubble) {
    var badge = bubble && bubble.firstElementChild;
    if (!badge) return;
    var count = countFromText(badge.textContent);
    var hide = count <= 0;
    if (badge.classList.contains('hidden') !== hide) badge.classList.toggle('hidden', hide);
    if (bubble.getAttribute('data-value') !== String(count)) bubble.setAttribute('data-value', String(count));
  }

  function watch(doc, Observer) {
    IDS.forEach(function (id) {
      var bubble = doc.getElementById(id);
      if (!bubble || bubble.getAttribute('data-tw-count-sync') === '1') return;
      bubble.setAttribute('data-tw-count-sync', '1');
      // Nur Text und Kinder beobachten, nicht Attribute: Das Umschalten der Klasse löst so
      // keinen neuen Durchlauf aus.
      new Observer(function () { sync(bubble); }).observe(bubble, { childList: true, subtree: true, characterData: true });
      sync(bubble);
    });
  }

  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return;
  watch(document, MutationObserver);
})();
